import { useQuery } from '@apollo/client';
import { AppSyncFarm, MonitorVaults } from 'common/models/farm';
import { QueryItemsResponse } from 'common/models/graphql';
import { REFRESH_INTERVALS, VAULT_INFO_TABLE } from 'constants/constants';
import React, { FC } from 'react';
import VaultsInfoTable from 'common/components/VaultsInfoTable/VaultsInfoTable';
import { listMonitorVaultsQuery } from 'graphql/queries/listMonitorVaults.query';
import SpinnerContainer from 'common/components/SpinnerContainer';
import { listFarmsQuery } from 'graphql/queries/listFarmsAll.query';
import { RouteComponentProps } from '@reach/router';

const VaultInfoContainer: FC<RouteComponentProps> = () => {
  // fetch data for all chains
  const { loading: loadingFarms, data: dataFarms } = useQuery<
    QueryItemsResponse<AppSyncFarm>
  >(listFarmsQuery(), {
    fetchPolicy: 'cache-and-network',
    pollInterval: REFRESH_INTERVALS['listFarms'],
  });
  const { loading: loadingMonitorVaults, data: dataMonitorVaults } = useQuery<
    QueryItemsResponse<MonitorVaults>
  >(listMonitorVaultsQuery, {
    fetchPolicy: 'cache-and-network',
    pollInterval: REFRESH_INTERVALS['listMonitorVaults'],
  });

  const appSyncFarms: AppSyncFarm[] =
    dataFarms?.listFarms?.items.filter((item) => item.isPosition) || [];
  const monitoVaults: MonitorVaults[] =
    dataMonitorVaults?.listMonitorVaults.items || [];

  const table = VAULT_INFO_TABLE;
  return (
    <>
      <div className="table-wrapper">
        <div className="flex flex-row justify-start gap-10 primary-text-color pb-7 pt-5 text-2xl font-semibold">
          Vault Metrics
        </div>
        <SpinnerContainer isLoading={loadingFarms || loadingMonitorVaults}>
          <VaultsInfoTable
            table={table}
            farms={appSyncFarms}
            monitorVaults={monitoVaults}
          />
        </SpinnerContainer>
      </div>
    </>
  );
};

export default VaultInfoContainer;
